/**
 * Renders untrusted model markdown to sanitised HTML.
 * Every HTML path — including the settled stream — goes through DOMPurify.
 * Angle brackets are escaped before parse so tag-like phrases stay visible
 * and raw HTML from the model cannot become elements.
 */

import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ gfm: true, breaks: true });

function escapeAngleBrackets(text) {
  return (text || "").toString().replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function sanitizeStreamText(text) {
  return (text || "").toString();
}

export function renderMarkdown(text) {
  return DOMPurify.sanitize(marked.parse(escapeAngleBrackets(text)));
}
